export interface User {
  userID: number;
  firstName: string;
  lastName: string;
  email: string;
  active: boolean;
  azureID?: string;
  typeID?: number;
}

export enum UserType {
  SuperAdmin = 1,
  Admin = 2,
  User = 3
}

const USER_TYPE_BY_NAME: Record<string, UserType> = {
  'super admin': UserType.SuperAdmin,
  'admin': UserType.Admin,
  'user': UserType.User
};

export function getUserTypeFromName(typeName: string): UserType | null {
  return USER_TYPE_BY_NAME[(typeName || '').trim().toLowerCase()] ?? null;
}

// Lower typeID means higher privilege: a user may only act on users of the same type or lower.
export function canManageUserType(adminType: UserType | null, targetTypeID: number | null | undefined): boolean {
  if (!adminType || targetTypeID == null) {
    return false;
  }
  return targetTypeID >= adminType;
}
